/** True when the property step listed at least one child (count or children[]). */
export function hasAnyChildren(
	propertyStepData: Record<string, unknown> | undefined,
): boolean {
	if (!propertyStepData) return false
	const children = propertyStepData.children
	if (Array.isArray(children) && children.length > 0) return true
	const count = Number(propertyStepData.numChildren)
	return Number.isFinite(count) && count > 0
}
